import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 font-pacifico">Eat Fresh by 2π</h3>
            <p className="text-sm sm:text-base text-teal-50">
              {t('footer.description')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">{t('footer.navigation')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors cursor-pointer">
                  {t('nav.home')}
                </a>
              </li>
              <li>
                <a href="#fresh-fish" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors cursor-pointer">
                  {t('nav.freshFish')}
                </a>
              </li>
              <li>
                <a href="#grilled-fish" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors cursor-pointer">
                  {t('nav.grilledFish')}
                </a>
              </li>
              <li>
                <a href="#about" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors cursor-pointer">
                  {t('nav.about')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors cursor-pointer">
                  {t('nav.contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base sm:text-lg"></i>
                <a href="tel:+237654391120" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors cursor-pointer">
                  +237 654 391 120
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-base sm:text-lg"></i>
                <a href="https://wa.me/237654391120" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base text-teal-50 hover:text-white transition-colors cursor-pointer">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base sm:text-lg"></i>
                <span className="text-sm sm:text-base text-teal-50">Douala, Cameroun</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">{t('footer.hours')}</h4>
            <div className="space-y-2">
              <p className="text-sm sm:text-base text-teal-50 font-semibold">{t('footer.everyday')}</p>
              <div className="flex items-center gap-2">
                <i className="ri-fish-line text-base"></i>
                <p className="text-sm text-teal-50">{t('footer.freshFishHours')}</p>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-fire-line text-base"></i>
                <p className="text-sm text-teal-50">{t('footer.grilledDeliveryHours')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm text-teal-50 mb-2">
            {t('footer.rights')}
          </p>
          <p className="text-xs text-teal-100">
            {t('footer.poweredBy')}
          </p>
        </div>
      </div>
    </footer>
  );
}
